import { useEffect, useState } from 'react';
import { navLinks } from '@/mocks/content';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    onScroll();
    window.addEventListener('scroll', onScroll);
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  const solid = scrolled || menuOpen;

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        solid ? 'bg-background-50/95 backdrop-blur border-b border-background-200' : 'bg-transparent'
      }`}
    >
      <nav className="w-full px-4 md:px-8 h-16 md:h-20 flex items-center justify-between">
        <a href="#top" className="flex items-center gap-2 cursor-pointer">
          <span
            className={`w-9 h-9 flex items-center justify-center rounded-md ${
              solid ? 'bg-primary-500 text-background-50' : 'bg-primary-500 text-background-50'
            }`}
          >
            <i className="ri-film-line text-xl" />
          </span>
          <span className={`text-lg md:text-xl font-black tracking-wide ${solid ? 'text-foreground-950' : 'text-background-50'}`}>
            星辰影院
          </span>
        </a>

        <ul className="hidden lg:flex items-center gap-7">
          {navLinks.map((link) => (
            <li key={link.id}>
              <a
                href={`#${link.id}`}
                className={`text-sm transition-colors cursor-pointer ${
                  solid ? 'text-foreground-600 hover:text-primary-600' : 'text-background-100/90 hover:text-accent-300'
                }`}
              >
                {link.label}
              </a>
            </li>
          ))}
        </ul>

        <div className="flex items-center gap-3">
          <a
            href="#today"
            className="hidden md:inline-flex items-center gap-1.5 h-9 px-4 rounded-md bg-primary-500 text-background-50 text-sm font-medium whitespace-nowrap hover:bg-primary-600 transition-colors cursor-pointer"
          >
            <i className="ri-flashlight-line" />
            看今日更新
          </a>
          <button
            type="button"
            aria-label="打开导航菜单"
            onClick={() => setMenuOpen((v) => !v)}
            className={`lg:hidden w-10 h-10 flex items-center justify-center rounded-md border ${
              solid ? 'border-background-300 text-foreground-900' : 'border-background-100/40 text-background-50'
            }`}
          >
            <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'} />
          </button>
        </div>
      </nav>

      {menuOpen && (
        <div className="lg:hidden bg-background-50 border-t border-background-200 px-4 py-4">
          <ul className="grid grid-cols-2 gap-2">
            {navLinks.map((link) => (
              <li key={link.id}>
                <a
                  href={`#${link.id}`}
                  onClick={() => setMenuOpen(false)}
                  className="block px-3 py-2.5 rounded-md bg-background-100 text-foreground-700 text-sm hover:bg-primary-100 hover:text-primary-700 transition-colors cursor-pointer"
                >
                  {link.label}
                </a>
              </li>
            ))}
          </ul>
        </div>
      )}
    </header>
  );
}